import { render } from "./IconCamera.vue.js?vue&type=template&id=2b977156!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconCamera.vue?vue&type=template&id=2b977156"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__